import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kahjuks sinu otsing ei andnud tulemusi.

  <span style="color:#85c1dc;">**FI:**</span>
  Valitettavasti hakusi ei tuottanut tulosta.

  <span style="color:#85c1dc;">**RU:**</span>
  К сожалению, Ваш поиск не дал результатов.
*/
/* @__NO_SIDE_EFFECTS__ */
const m795 = msg(
  mf`Kahjuks sinu otsing ei andnud tulemusi.`,
  mf`Valitettavasti hakusi ei tuottanut tulosta.`,
  mf`К сожалению, Ваш поиск не дал результатов.`,
)

export { m795 as 'w.module.no-results.search.title' }